import { repairGet, repairSave, SearchRepair, GetRepairMachine, TransferMachine, DelRenewRepair } from '@/api/repair'
export default {
  state: {

  },
  actions: {
    getRepair ({ commit }, payload) {
      return new Promise(resolve => {
        repairGet(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    saveRepair ({ commit }, payload) {
      return new Promise(resolve => {
        repairSave(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SearchRepair ({ commit }, payload) {
      return new Promise(resolve => {
        SearchRepair(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetRepairMachine ({ commit }, payload) {
      return new Promise(resolve => {
        GetRepairMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    TransferMachine ({ commit }, payload) {
      return new Promise(resolve => {
        TransferMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DelRenewRepair ({ commit }, payload) {
      return new Promise(resolve => {
        DelRenewRepair(payload).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  getters: {

  },
  mutations: {

  }
}
